<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, BLOCK } from '#library/components.schema.build.ts'
	import Video from '#components/video.svelte'
	import { ui } from '#library/stores.ts'
	import Controls from '#components/controls.svelte'
	import { onDestroy } from 'svelte'

	interface Props {
		blok: Blok<BLOCK>
	}

	let { blok }: Props = $props()
	let node = $state<HTMLVideoElement>()
	let paused = $state(false)
	let modal = $state(false)

	$ui.immersive = true

	onDestroy(() => ($ui.immersive = false))

	function play() {
		node?.play()
	}

	function pause() {
		node?.pause()
	}

	function full() {
		modal = true
	}
</script>

<section class="superhero {blok.theme}" {...attrs(blok)}>
	<Video video={blok.video} autoplay loop controls={false} bind:node bind:modal bind:paused />
	<!-- <svg class="logo"><use xlink:href="/images/vector.svg#icon"></use></svg> -->
	<!-- <figure class="figure">
		<svg class="logo"><use xlink:href="/images/vector.svg#icon"></use></svg>
	</figure> -->
	<div class="contain">
		<svelte:element this={blok.title.tag || 'div'} class="title">
			{blok.title.text}
		</svelte:element>
		<div class="controls">
			<Controls autoplay relative bind:paused {play} {pause} {full} />
		</div>
		<div class="scroll">
			<div class="icon">
				<svg class="svg"><use xlink:href="/images/vector.svg#arrow-up"></use></svg>
				<svg class="svg"><use xlink:href="/images/vector.svg#arrow-up"></use></svg>
			</div>
			Scroll for more
		</div>
	</div>
</section>

<style lang="css">
	.superhero {
		align-items: end;
		background-color: black;
		color: var(--c-gimson);
		display: grid;
		height: 100vh;
		padding-block: var(--padding-top, 0) var(--padding-bottom, 0);
		margin-block-start: -3.75rem;

		&::after {
			background-image: var(--pattern);
			content: '';
			display: block;
			height: 1.625rem;
			position: absolute;
			width: 100%;

			@media (--from-mobile) {
				height: 2rem;
			}
		}

		@media (--from-mobile) {
			margin-block-start: -6.9375rem;
		}

		:global {
			.player {
				inset: 0;
				opacity: 0.7;
				position: absolute;
			}
		}
	}

	.figure {
		inset: 65% auto auto 100%;
		position: absolute;
		size: 75vw;
		translate: -50% -50%;

		@media (--from-laptop) {
			inset: 50% auto auto 100%;
			size: 75vh;
		}

		&::before {
			background-color: var(--c-gimson-alpha);
			backdrop-filter: blur(12px);
			content: '';
			display: block;
			height: 100%;
			mask-image: url('/images/logo.svg');
			mask-position: center;
			mask-repeat: no-repeat;
			mask-size: contain;
			position: absolute;
			width: 100%;
		}
	}

	.logo {
		opacity: 0;
	}

	.contain {
		padding-block: 0 20vh;
	}

	.title {
		font: 500 var(--f-display);
		letter-spacing: var(--ls-display);
		max-width: 14ch;
		text-wrap: balance;
	}

	.scroll {
		font: 400 var(--f-h5);
		margin-block: 3rem;

		@media (--from-mobile) {
			margin-block: 4rem;
		}
	}

	.controls {
		margin: 1.5rem 0 0 0.25rem;
	}

	.scroll {
		align-items: center;
		display: flex;
		gap: 0.5rem;
		inset: auto auto 0 0;
		position: absolute;
	}

	.icon {
		rotate: 180deg;
		overflow: clip;
		size: 2rem;
	}

	.svg {
		animation: swipe 1.2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
		size: 100%;
	}

	@keyframes swipe {
		to {
			translate: 0 -100%;
		}
	}
</style>
